<template>
  <div :class="active ? '' : 'hidden'" style="width: 100%">
    <div class="text-qwray Text self-start">
      {{ $t('payment_methods.contactless.description1') }}
    </div>
    <div class="text-qwray Text self-start">
      {{ $t('payment_methods.contactless.description2') }}
    </div>
    <HStack
      :pstyle="{
        justifyContent: 'center',
        width: '100%',
        height: isMobile ? '45px' : '70px',
        marginTop: isMobile ? '2em' : '3em',
      }"
    >
      <img
        alt="MasterCard logo"
        class="IconTop"
        src="~@/assets/experiencePage/mastercard.svg"
      />
      <img
        alt="Maestro logo"
        class="IconTop"
        src="~@/assets/experiencePage/maestro.svg"
      />
      <img
        alt="Samsung logo"
        class="IconTop"
        src="~@/assets/experiencePage/samsung-pay.svg"
      />
    </HStack>
    <Space pheight="50px" />
    <HStack
      :pstyle="{
        justifyContent: 'space-evenly',
        width: '100%',
        height: isMobile ? '50px' : '70px',
      }"
    >
      <img
        alt="Visa logo"
        class="IconBottom"
        src="~@/assets/experiencePage/visa-ic@2x.png"
      />
      <div class="ImageWrapper">
        <picture>
          <source
            type="image/webp"
            srcset="~@/assets/experiencePage/v-pay@2x.webp"
          />
          <img
            alt="V-Pay logo"
            class="IconBottom"
            src="~@/assets/experiencePage/v-pay@2x.png"
          />
        </picture>
      </div>
      <img
        alt="Apple Pay logo"
        class="IconBottom"
        src="~@/assets/experiencePage/apple-pay.svg"
      />
      <img
        alt="Google Pay logo"
        class="IconBottom"
        src="~@/assets/experiencePage/google-pay.svg"
      />
    </HStack>
    <div class="Details" v-show="matchEntities(['UK', 'SWEDEN', 'GERMANY'])">
      {{ $t('payment_methods.contactless.description3') }}
    </div>
  </div>
</template>
<script>
import { HStack } from '../../../layout/flexbox';
import Space from '../../../layout/space';
import matchEntities from '../../../shared/entityHelpers';

export default {
  components: { HStack, Space },
  props: ['active', 'isMobile'],
  methods: {
    matchEntities,
  },
};
</script>

<style scoped>
.ImageWrapper {
  width: auto !important;
  height: 100% !important;
}
.pics img {
  width: 110px;
  @apply ml-16;
}

.IconTop {
  --icon-margin: 1em;
  width: 25% !important;
  height: auto !important;
  max-height: 100%;
  object-fit: contain;
}
.IconBottom {
  width: auto !important;
  height: 100% !important;
}
.IconBottom,
.IconTop {
  margin-right: var(--icon-margin);
}

.Text {
  font-size: 14px;
}

.Details {
  color: #a1b1b5;
  letter-spacing: 0.16px;
  font-size: var(--details-f-size);
  max-width: calc((var(--rect-w) * 2) + var(--day-margin-right));
  margin: 4.5em auto 0 auto;
}

@media (min-width: 768px) {
  .IconTop {
    --icon-margin: 3em;
  }
  .Text {
    font-size: 16px;
  }
}
@media (min-width: 1400px) {
  .Text {
    font-size: 18px;
  }
}

@media (min-width: 1600px) {
  .Text {
    font-size: 20px;
  }
}
</style>
